<template>
  <div class="animated fadeIn">

    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col lg="6">
            <b-form-group label="From" label-cols-sm="4" label-cols-lg="3">
              <v-date-picker :formats='dateformats' v-model="fromDate" :input-props='{ class: "form-control" }' show-caps>
              </v-date-picker>
            </b-form-group>

          </b-col>
          <b-col lg="6">
            <b-form-group label="To" label-cols-sm="4" label-cols-lg="3">
              <v-date-picker :formats='dateformats' v-model="toDate" :input-props='{ class: "form-control" }' show-caps>
              </v-date-picker>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
            <b-button variant="primary" class="pull-right" @click="search" :disabled="fromDate > toDate">
              Search
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card>
      <v-client-table :columns="columns" :data="visitors" :options="options" :theme="theme" id="dataTable"
        ref="dataTable">
        <template slot="child_row" slot-scope="data">
          <b-row>
            <b-col lg="6">
              <b-table :items="data.row.members" :fields="fields" striped></b-table>
            </b-col>
            <b-col lg="6">
              <b-card title="Comments">{{ data.row.comments }}</b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <room-selected :reservation="data.row" :viewOnly=true ref="roomSelected"></room-selected>
            </b-col>
          </b-row>
        </template>
        <template slot="id_card_no" slot-scope="data">
          {{ data.row.id_card_no ? data.row.id_card_no : translateReason(data.row.id_card_reason) }}
        </template>
        <template slot="created_at" slot-scope="data">
          {{ $moment(data.row.created_at).format('YYYY-MM-DD') }}
        </template>
        <template slot="is_child" slot-scope="data">
          {{ data.row.is_child ? 'Yes' : 'No' }}
        </template>
        <template slot="actions" slot-scope="data">
          <b-button v-if="data.row.acco_checkin_status == 'No'" size="sm" class="mr-1" variant="success"
            @click="checkin(data.row)">Check In</b-button>
          <b-button v-if="data.row.bhandarghar_ticket == 'YES'" size="sm" class="mr-1" variant="info"
            @click="printTickets(data.row)">Print Ticket</b-button>
          <b-button v-if="data.row.bhandarghar_ticket == 'NO'" size="sm" class="mr-1" variant="danger"
            @click="generateTickets(data.row)">Generate and Print Ticket</b-button>
        </template>
      </v-client-table>
    </b-card>
    <div id="mealCardList" style="display:none;">
      <meal-print-card ref="mealPrintCardList"></meal-print-card>
    </div>
  </div>
</template>  
<script>
import { mapState, mapActions } from 'vuex'
import Vue from 'vue'
import RoomSelected from './RoomSelected'
import MealPrintCard from './MealPrintCard'
export default {
  name: 'AccomodationReservationsList',
  components: {
    RoomSelected,
    MealPrintCard
  },
  computed: {
  },
  data: function () {
    return {
      allowMultiple: false,
      selectedReservationObject: {},
      selectedReservation: null,
      selectedAutoReservation: null,
      mealColumns: ['Date', 'Lunch', 'Dinner'],
      fields: ['name', 'age', 'i_card_number'],
      columns: [
        'event_type.name',
        'id_card_no',
        'application_number',
        'applicant_name',
        'acco_checkin_status',
        'arrival_date',
        'departure_date',
        'members_count',
        'actions'
      ],
      options: {
        headings: {
          'event_type.name': 'Bhandara/Satsang',
          id_card_no: 'Id Card (or reason)',
          application_number: 'Reservation Reference',
          applicant_name: 'Applicant',
          'customer.city': 'City',
          members_count: 'Members',
          arrival_date: 'Arrival',
          departure_date: 'Departure',
          acco_checkin_status: 'Checked In?'
        },
        sortable: ['arrival_date', 'departure_date', 'status', 'members_count'],
        filterable: ['application_number'],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
        cellClasses: {
          is_child: [
            {
              class: 'font-weight-bold',
              condition: row => row.is_child == 1
            }
          ]
        }
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
      fromDate: new Date(),
      toDate: new Date(),
      visitors: [],
      tickets: []

    }
  },
  methods: {
    sleep(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms)
        })
      },
      generateTickets(reservation){      
      let params = {
        reservation_id: reservation['id']        
      }

      Vue.axios.post('/admin/getBhandargharTickets', params)
        .then(response => {
          try {
            if (response.data != null && response.data.success == false) {
              this.showErrorMsg({
                message: response.data.error
              })
            }
            else if (response.status == 422) {
              this.showErrorMsg({
                message: response.data.message
              })
            }
            else {
              this.showSuccessMsg()
              this.printTickets(response.data.data.data)   
              this.search();           
            }
          } catch (exception) {
            this.showErrorMsg({
              message: exception
            })
          }


        })
        .catch(error => {

          this.showErrorMsg({
            message: error
          })
        });

      },
   async printTickets(reservation) {
      
      if (reservation != null && reservation.ticket != null && reservation.ticket.meals != null && reservation.ticket.meals.length > 0) {
        let Reservationmeals = reservation.ticket.meals;
        let prdMealDates = [];
        Reservationmeals.forEach( (meal) =>  {            
          
          let mealDates = this.getDates(meal['mealfromdate'], meal['mealtodate']);
          let prdType = meal.product.category.mealtype;
          
          prdMealDates[prdType] = prdMealDates[prdType]? prdMealDates[prdType].concat(mealDates) : mealDates;
      
        }, this);           
       
        let phone = reservation.phone;
      
        let persons = [];
       reservation.members.forEach((member) => {     
        let person = [];     
        person['name'] = member.name
        person['idcard'] = member.i_card_number
        person['phone'] = phone
        persons.push(person);
        }, this)

        console.log(persons);

        this.$refs.mealPrintCardList.setCardData(prdMealDates,  reservation.arrival_date,  reservation.departure_date, persons);  
        await this.sleep(1000);      
        this.$htmlToPaper('mealCardList')
        this.$refs.mealPrintCardList.resetData();
      
      
    }
      else {        
        this.showErrorMsg({
          message: 'Reservation does not have ticket generated.'
        })
      }

    },
    search() {
      this.visitors = []
      let params = {
        from: this.$moment(this.fromDate).format('YYYY-MM-DD'),
        to: this.$moment(this.toDate).format('YYYY-MM-DD')
      }

      Vue.axios.post('/admin/reservationsByRange?status=PAID', params)
        .then(response => {
          try {
            if (response.data != null && response.data.success == false) {
              this.showErrorMsg({
                message: response.data.error
              })
            }
            else if (response.status == 422) {
              this.showErrorMsg({
                message: response.data.message
              })
            }
            else {
              this.visitors = response.data.data
              this.showSuccessMsg()
            }
          } catch (exception) {
            this.showErrorMsg({
              message: exception
            })
          }


        })
        .catch(error => {

          this.showErrorMsg({
            message: error
          })
        });
    },

    checkin(row) {
      console.log(row);
      this.$store.dispatch('reservations/updateCheckinReservation', { id: row.id, type: 'ACCO' })
        .then((response) => {
          try {
            if (response.data != null && response.data.success == false) {
              this.showErrorMsg({
                message: response.data.error
              })
            }
            else {
              this.showSuccessMsg()
              this.search();
            }
          } catch (exception) {
            this.showErrorMsg({
              message: exception
            })
          }

        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.showErrorMsg({
              message: error.response.data.message
            })
          } else {
            this.showErrorMsg()
          }
        })
    },
    translateReason(reason) {
      switch (reason) {
        case 'NEW_TO_SATSANG':
          return 'New to Satsang'
        case 'SUPPORT_ELDER_PERSON':
          return 'Support to elder person'
        case 'CHILD':
          return 'Child'
      }
      return ''
    }
  },
}
</script>
    